import gql from 'graphql-tag';

export const GET_GOOGLE_ID_TOKEN = gql`
  query googleIdToken($code: String!, $redirectUri: String!) {
    googleIdToken(code: $code, redirectUri: $redirectUri) {
      idToken
    }
  }
`;
